import React from 'react';
import { Box, Typography, SxProps, Theme } from '@mui/material';
import { InfoOutlined as InfoOutlinedIcon } from '@mui/icons-material';

export type SalesStepHintTone = 'info' | 'success' | 'warning';

const TONE_COLORS: Record<SalesStepHintTone, string> = {
  info: 'info.main',
  success: 'success.main',
  warning: 'warning.main',
};

interface SalesStepHintProps {
  children: React.ReactNode;
  tone?: SalesStepHintTone;
  sx?: SxProps<Theme>;
}

const SalesStepHint: React.FC<SalesStepHintProps> = ({ children, tone = 'info', sx }) => {
  const color = TONE_COLORS[tone];

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1,
        mb: 2,
        ...sx,
      }}
    >
      <InfoOutlinedIcon sx={{ fontSize: 18, color, mt: '2px', flexShrink: 0 }} />
      <Typography variant="body2" sx={{ color, lineHeight: 1.5 }}>
        {children}
      </Typography>
    </Box>
  );
};

export default SalesStepHint;
